import React, { useState, useEffect } from "react";
import Modal from "./Modal";

export default function AddCustomerModal({
  isOpen,
  onClose,
  onSubmit,
  initialData,
}) {
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    notes: "",
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name || "",
        phone_number: initialData.phone_number || initialData.phone || "",
        notes: initialData.notes || "",
      });
    } else {
      setFormData({
        name: "",
        phone_number: "",
        notes: "",
      });
    }
  }, [initialData, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    onClose();
  };

  const title = initialData ? "Edit Data Pelanggan" : "Tambah Data Pelanggan";

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      headerColor="bg-teal-600">
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Nama Pelanggan */}
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1.5">
            Nama Pelanggan <span className="text-rose-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Contoh: Nanda Silvi Aulia"
            className="w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent focus:bg-white transition-colors"
            required
          />
        </div>

        {/* No Handphone */}
        <div>
          <label className="block text-xs font-medium text-slate-600 mb-1.5">
            No Handphone <span className="text-rose-500">*</span>
          </label>
          <input
            type="text"
            name="phone_number"
            value={formData.phone_number}
            onChange={handleChange}
            placeholder="Contoh: 081234567890"
            className="w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent focus:bg-white transition-colors"
            required
          />
        </div>

        {/* Catatan (Hanya tampil pada Tambah Data Pelanggan, di-hide pada Edit Data Pelanggan) */}
        {!initialData && (
          <div>
            <label className="block text-xs font-medium text-slate-600 mb-1.5">
              Catatan
            </label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Masukkan catatan jika diperlukan (misal: Alergi udang, Pelanggan VIP, dll)"
              rows="4"
              className="w-full bg-slate-50 border border-slate-200 rounded-lg px-3 py-2 text-sm text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent focus:bg-white transition-colors resize-none"
            />
          </div>
        )}

        {/* Submit Button */}
        <div className="flex justify-end pt-2">
          <button
            type="submit"
            className="px-5 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium text-sm shadow-sm shadow-teal-600/20">
            Simpan Data
          </button>
        </div>
      </form>
    </Modal>
  );
}
